/**
 * Utils for handling event-specific tags
 */
import { EVENT_TAGS } from '../constants/rugbyConstants';

/**
 * Get tags for a specific event type
 * 
 * @param {string} eventType - The type of event
 * @returns {Array} - Array of tag objects with id and label
 */
export const getTagsForEventType = (eventType) => {
  return EVENT_TAGS[eventType] || [];
};

/**
 * Reset selected tags and comment
 * Used after recording an event
 * 
 * @param {Function} setSelectedTags - Function to update selected tags
 * @param {Function} setComment - Function to update comment
 */
export const resetTagsAndComment = (setSelectedTags, setComment) => {
  setSelectedTags([]);
  setComment('');
};

/**
 * Get tag label from ID
 * 
 * @param {string} tagId - ID of the tag
 * @param {string} eventType - Type of event (for context)
 * @returns {string} - Human readable label for the tag
 */
export const getTagLabel = (tagId, eventType) => {
  const tags = getTagsForEventType(eventType);
  const tag = tags.find(t => t.id === tagId);
  return tag ? tag.label : tagId;
};